import React, { useState } from 'react'
import { Box, Link as ExternalLink } from 'rebass/styled-components'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Link } from 'gatsby'

const MobileMenu = styled(Box)`
    background-color: ${(props) => props.theme.colors.aquaLight};
    border-color: ${(props) => props.theme.colors.white};
    border-style: solid;
    border-width: 45px 0 0 0;
    left: 0;
    letter-spacing: 1.1px;
    position: absolute;
    text-align: center;
    top: 0;
    width: 100%;
    z-index: -1;

    display: none;

    @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
        display: block;
    }

    ul {
        font-size: ${(props) => props.theme.fontSizes.sm};
        list-style: none;
        margin-top: ${(props) => props.theme.space.xxl};
        padding: 0;

        ul {
            background-color: ${(props) => props.theme.colors.white};
            display: block;
            margin-top: 0;
            position: relative;
        }

        li {
            display: block;
            position: relative;

            :before {
                background-color: ${(props) => props.theme.colors.aquaMedium};
                bottom: auto;
                content: '';
                display: block;
                height: 1px;
                left: 2%;
                position: absolute;
                top: 0;
                width: 96%;
            }

            :first-child:before {
                display: none;
            }

            &.active {
                background-color: ${(props) => props.theme.colors.aquaDark};
                font-weight: ${(props) => props.theme.fontWeights.bold};

                li {
                    font-weight: ${(props) => props.theme.fontWeights.regular};

                    &.active {
                        background-color: ${(props) => props.theme.colors.white};
                        font-weight: ${(props) => props.theme.fontWeights.bold};
                    }

                    a {
                        padding-bottom: ${(props) => props.theme.space.md};
                        padding-top: ${(props) => props.theme.space.md};
                        transition-property: none;

                        :hover {
                            font-weight: ${(props) => props.theme.fontWeights.bold};
                        }
                    }
                }
            }
        }

        li li a {
            will-change: color;

            :hover {
                background-color: transparent;
                color: ${(props) => props.theme.colors.aquaDark};
            }
        }

        a {
            background-color: transparent;
            color: ${(props) => props.theme.colors.black};
            cursor: pointer;
            display: block;
            padding-bottom: ${(props) => props.theme.space.sm};
            padding-top: ${(props) => props.theme.space.sm};
            position: relative;
            text-decoration: none;

            &.hasChildren:after {
                border-style: solid;
                border-width: 24px 22px 0 22px;
                border-color: ${(props) => props.theme.colors.aquaLight} transparent transparent transparent;
                bottom: -12px;
                content: '';
                display: block;
                position: absolute;    
                height: 0;
                left: calc(50% - 22px);
                top: auto;
                width: 0;
                z-index: 1;
            }
            
            :hover {
                background-color: ${(props) => props.theme.colors.aquaDark};
            }
            &.hasChildren:hover:after,
            &.hasChildren.active:after {
                border-color: ${(props) => props.theme.colors.aquaDark} transparent transparent transparent;
            }
            &.active {
                background-color: ${(props) => props.theme.colors.aquaDark};
                font-weight: ${(props) => props.theme.fontWeights.bold};
                padding-bottom: ${(props) => props.theme.space.md};
                padding-top: ${(props) => props.theme.space.md};
                transition-property: none;
            }
            &.active + .subnav-container {
                display: block;
            }
        }
    }
`

const MobileMenuOption = styled(Box)`
    font-weight: ${(props) => props.theme.fontWeights.bold};
    display: none;
    position: absolute;
    right: 0;
    top: 0;

    &.contact {
        font-weight: ${(props) => props.theme.fontWeights.regular};
        left: 0;
        right: auto;
    }

    a {
        color: ${(props) => props.theme.colors.black};
        cursor: pointer;
        display: block;
        line-height: 45px;
        padding-bottom: 0;
        padding-left: ${(props) => props.theme.space.sm};
        padding-right: ${(props) => props.theme.space.sm};
        padding-top: 0;
        text-align: center;
        text-decoration: none;
        white-space: nowrap;
    }

    @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
        display: block;
    }
`

const PrimaryMobile = () => {
    const [open, setOpen] = useState(false)

    return (
        <>
            <MobileMenuOption onClick={ () => setOpen(!open) }>
                <Link to="#">
                    Menu
                </Link>
            </MobileMenuOption>
            <MobileMenuOption className="contact">
                <Link to="/contact">
                    Contact
                </Link>
            </MobileMenuOption>
            <MobileMenu
                as="nav"
                itemType="http://schema.org/SiteNavigationElement"
                itemScope="itemscope"
                role="navigation"
            >
                <Box as='ul' sx={{
                    display: open ? 'block' : 'none',
                }}>
                    <li>
                        {/* <Link to="/about" onClick={(e) => someFunction(e, 'about')} className='hasChildren' activeClassName="active" partiallyActive> */}
                        <Link to="/about" className='hasChildren' activeClassName="active" partiallyActive>
                            About
                        </Link>
                        <ul>
                            <li>
                                <Link to="/about" onClick={() => setOpen(false)}>
                                    The Company
                                </Link>
                            </li>
                            <li>
                                <Link to="/about/services" onClick={() => setOpen(false)}>
                                    Our Services
                                </Link>
                            </li>
                            {/* <li>
                                <Link to="/galleries" onClick={() => setOpen(false)}>
                                    Gallery
                                </Link>
                            </li> */}
                            <li>
                                <Link to="/about/testimonials" onClick={() => setOpen(false)}>
                                    Testimonials
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <Link to="/cars-for-sale/available" className='hasChildren' activeClassName="active" partiallyActive>Cars</Link>
                        <ul>
                            <li>
                                <Link to="/cars-for-sale/available" onClick={() => setOpen(false)}>
                                    Offered for Sale
                                </Link>
                            </li>
                            <li>
                                <Link to="/cars-for-sale/sold" onClick={() => setOpen(false)}>
                                    Previously Handled
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li><Link to="/restorations">Restorations</Link></li>
                    <li><Link to="/films">Films</Link></li>
                    <li><Link to="/publications">Publications</Link></li>
                    <li>
                        <Link to="#" className='hasChildren' activeClassName="active" partiallyActive>K-Ops</Link>
                        <ul>
                            <li><ExternalLink target="_blank" href="https://topmotorsalvioli.com/">Top Motors Salvioli</ExternalLink></li>
                            {/* <li><ExternalLink target="_blank" href="https://miurabook.com/shop/the-lamborghini-miura-book-register-only/">Miura Book</ExternalLink></li> */}
                            <li><ExternalLink target="_blank" href="https://k500.com/">K500</ExternalLink></li>
                            <li><ExternalLink target="_blank" href="https://miuraregister.com/">Online Miura Register</ExternalLink></li>
                        </ul>
                    </li>
                    <li><Link to="/contact">Contact</Link></li>
                </Box>
            </MobileMenu>
        </>
    )
}

function mapStateToProps(state) {
    return {}
}
export default connect(mapStateToProps)(PrimaryMobile)
